import { useDispatch, useSelector } from "react-redux";
import { fieldsToCheckProject } from "../../../data/permitFormsData";
import FinancialBPModal from "../FinancialBPModal";
import React from "react";
import { setBuildingState } from "../../../store/actions/permitFormActions/buildingStateActions";

const AddingNewProjectModal = () => {
  const { addingNewProject } = useSelector((state) => state.buildingState);

  const dispatch = useDispatch();

  return (
    <FinancialBPModal
      type="project"
      open={addingNewProject}
      title={"Add New Project Contact"}
      handleStateNo={() => {
        dispatch(setBuildingState({ addingNewProject: false }));
      }}
      fieldsToCheck={fieldsToCheckProject}
    />
  );
};

export default React.memo(AddingNewProjectModal);
